import EntryHeader from '@/components/EntryHeader'
import Main from '@/components/Main'
import Posts from '@/components/Posts'
import SEO from '@/components/SEO'
import styles from '@/styles/pages/_Single.module.scss'
import { formatDate } from '@/utilities/contentHelpers'
import Image from 'next/image'

export default function Component(props) {
  if (props.loading) {
    return null
  }

  if (!props?.data?.post) {
    return null
  }

  const metaDesc = props?.data?.post?.seo?.metaDesc
  const { title, content, featuredImage, date, author, authors } = props.data.post
  const coAuthor = authors?.nodes?.[0]
  const primaryAuthor = coAuthor ?? author?.node
  const formattedDate = formatDate(date)
  const seoTitle = props?.data?.post?.seo?.title

  return (
    <>
      <SEO title={seoTitle || title} description={metaDesc} imageUrl={featuredImage?.node?.sourceUrl} />

      <Main>
        <EntryHeader title={title} image={featuredImage?.node} formattedDate={formattedDate} post={props.data.post} isSinglePost={true} />

        <div className={styles.postContainer} data-cy="post-container">
          {primaryAuthor && (
            <div className={styles.postAuthor} data-cy="post-author">
              {coAuthor?.authorFields?.authorHeadshot?.node?.sourceUrl ? (
                <Image
                  src={coAuthor.authorFields.authorHeadshot.node.sourceUrl}
                  className={styles.authorHeadshot}
                  height={200}
                  width={200}
                  alt={coAuthor.authorFields.authorHeadshot.node.altText || `${primaryAuthor.name} headshot`}
                />
              ) : (
                <Image src="/silhouette.svg" className={styles.authorHeadshot} height={200} width={200} alt="Author silhouette" />
              )}
              <p className={styles.authorName} data-cy="post-author-name">
                By {primaryAuthor.name}
              </p>
            </div>
          )}

          <div className={styles.postContent} data-cy="post-content" dangerouslySetInnerHTML={{ __html: content }} />
        </div>

        <div className="container">
          <section className={styles.posts}>
            <Posts posts={props?.data?.posts?.nodes} id="posts-list" />
          </section>
        </div>
      </Main>
    </>
  )
}
